var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56982 8.66668H21.4302C20.0573 4.78285 16.354 2 12 2C7.64607 2 3.94271 4.78285 2.56982 8.66668Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 13.1689 2.20125 14.2907 2.5698 15.3333H21.4302C21.7987 14.2907 22 13.1689 22 12C22 10.8311 21.7987 9.70934 21.4302 8.66668H2.5698C2.20125 9.70934 2 10.8311 2 12Z",
    fill: "#00966E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4302 15.3333H2.56982C3.94271 19.2171 7.64607 22 12 22C16.354 22 20.0573 19.2171 21.4302 15.3333Z",
    fill: "#D62612"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBg);
export default __webpack_public_path__ + "static/media/flag-bg.d3f0e36e096520345e4012572933cf46.svg";
export { ForwardRef as ReactComponent };